import { render, staticRenderFns } from "./ticket_reference_types.vue?vue&type=template&id=513c2419&scoped=true&"
import script from "./ticket_reference_types.vue?vue&type=script&lang=js&"
export * from "./ticket_reference_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c2419",
  null
  
)

export default component.exports